import React from "react";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import AboutUs from "./components/abouUs/AboutUs";
import Services from "./components/sevices/Services";
import Footer from "./components/footer/Footer";
import ServiceSPA from "./components/serviceSpa/ServiceSPA";
import Doctors from "./components/doctors/Doctors";
import ContactPage from "./components/contact/ContactPage";
import Appointment from "./components/appointment/Appointment";
import News from "./components/news/News";
import NewsSpa from "./components/newsSpa/NewsSpa";
import DoctorsProfile from "./components/profile/Doctors";

// Style \\
import "./assets/styles/general.scss";

const Public = () => {
  return (
    <div>
      <header>
        <Header />
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/aboutUs" element={<AboutUs />}></Route>
          <Route path="/services" element={<Services />}></Route>
          <Route path="/doctors" element={<Doctors />}></Route>
          <Route path="/contact" element={<ContactPage />}></Route>
          <Route path="/news" element={<News />}></Route>
          <Route path="/appointment" element={<Appointment />}></Route>

          <Route path="/doctorsProfile" element={<DoctorsProfile />}></Route>
          <Route path="/servicesid" element={<ServiceSPA />}></Route>
          <Route path="/newsid" element={<NewsSpa />}></Route>
        </Routes>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Public;
